module.exports = __webpack_public_path__ + "static/media/6.33cb0afd.jpg";